import React from "react";
import "./ConfirmPopup.css";

const ConfirmPopup = ({ visible, onConfirm, onCancel }) => {
  if (!visible) return null;

  return (
    <div className="confirm-overlay">
      <div className="confirm-box">
        <h3>⚠️ Esta vista puede tardar hasta 3 minutos en cargar</h3>
        <p>¿Deseas continuar?</p>
        <div className="confirm-buttons">
          <button className="cancel-btn" onClick={onCancel}>
            Cancelar
          </button>
          <button className="accept-btn" onClick={onConfirm}>
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
